<template>
  <el-dialog
    title="售后设置"
    :visible.sync="visible"
    center
    width="800px"
    @close="handlerCancel"
  >
    <el-form ref="form" :model="form" label-width="240px" v-loading="loading" class="aftersale-config-form">
      <el-divider content-position="left"><span class="divider-text">自动售后设置</span></el-divider>
      <el-form-item label="上家延迟申请售后规则">
        <el-radio-group
          v-model="form.auto_aftersale_delay_rule"
          @change="handleDelayRuleChange"
        >
          <el-radio :label="DELAY_RULE_ALL">全部</el-radio>
          <el-radio :label="DELAY_RULE_PRICE_RANGE">按价格区间</el-radio>
        </el-radio-group>
        <p class="form-tip">选择「按价格区间」时，仅对区间内价格的订单延迟申请售后</p>
      </el-form-item>
      <template v-if="form.auto_aftersale_delay_rule === DELAY_RULE_PRICE_RANGE">
        <el-form-item label="上家延迟申请售后区间">
          <el-input
            size="small"
            class="delay-price-range-input"
            v-model="form.auto_aftersale_delay_min_price"
            placeholder="请输入"
          />
          <span class="delay-price-range-separator">元 ~ </span>
          <el-input
            size="small"
            class="delay-price-range-input"
            v-model="form.auto_aftersale_delay_max_price"
            placeholder="请输入"
          />
          <span class="delay-price-range-separator">元</span>
          <p class="form-tip">最低价格须小于最高价格，且均须大于 0</p>
        </el-form-item>
      </template>
      <el-form-item label="自动售后延迟时间">
        <el-input size="small" v-model="form.auto_aftersale_delay" placeholder="请输入">
          <template slot="append">分钟</template>
        </el-input>
        <p class="form-tip">自动处理售后前延迟的分钟数，0 表示不延迟</p>
      </el-form-item>
      <el-form-item label="卖家拒绝售后时自动再申请次数">
        <el-input size="small" v-model="form.auto_retry_apply_refund_num" placeholder="请输入">
          <template slot="append">次</template>
        </el-input>
        <p class="form-tip">卖家拒绝售后后，系统自动重新申请售后的次数</p>
      </el-form-item>
      <el-divider content-position="left"><span class="divider-text">售后说明设置</span></el-divider>
      <el-form-item label="未发货仅退款说明">
        <el-input
          size="small"
          v-model="form.aftersale_carry_refund_desc"
          placeholder="例：不想买了，谢谢"
        />
        <p class="form-tip">非必填，申请上家售后时，自动填写的描述</p>
      </el-form-item>
      <el-form-item label="已发货仅退款说明">
        <el-input
          size="small"
          v-model="form.aftersale_delivery_refund_desc"
          placeholder="例：不想买了，谢谢"
        />
        <p class="form-tip">非必填，申请上家售后时，自动填写的描述</p>
      </el-form-item>
      <el-form-item label="退货退款说明">
        <el-input
          size="small"
          v-model="form.aftersale_return_refund_desc"
          placeholder="例：不想买了，谢谢"
        />
        <p class="form-tip">非必填，申请上家售后时，自动填写的描述</p>
      </el-form-item>

      <el-divider content-position="left"><span class="divider-text">高级设置</span></el-divider>
      <el-form-item label="撤销申请" class="checkbox-form-item">
        <el-checkbox
          v-model="form.is_auto_cancel_apply"
          :true-label="1"
          :false-label="0"
          label="买家撤销售后申请，自动去上家撤销申请"
        />
      </el-form-item>
      <el-form-item label="售后挽单" class="checkbox-form-item" style="display: none;">
        <el-checkbox
          v-model="form.is_aftersale_retention"
          :true-label="1"
          :false-label="0"
          label="卖出单发起售后挽单时，采购单不申请售后"
        />
        <el-tooltip placement="top">
          <div slot="content">售后挽单：抖店售后订单自动挽回功能，<el-link type="primary" target="_blank" href="https://fxg.jinritemai.com/ffa/maftersale/aftersale/redeem/assistant?btm_ppre=a2427.b90384.c49158.d0&btm_pre=a2427.b687601.c67024&btm_show_id=889fce19-60e4-42a8-becf-d71b8c4741d5#/">查看详情>></el-link></div>
          <i class="question-icon el-icon-question"></i>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="部分退款" class="checkbox-form-item">
        <el-checkbox
          v-model="form.is_partial_refund_no_auto_apply"
          :true-label="1"
          :false-label="0"
          @change="handlePartialRefundNoAutoApplyChange"
          label="卖出单申请部分退款时，采购单不申请售后"
        />
        <el-tooltip placement="top">
          <div slot="content">
            举例说明：<br/>
            卖出单宝贝100元，用户申请仅退款50元<br />
            勾选该设置项：采购单不自动去上家申请售后，需手动申请<br />
            未勾选该设置项：采购单自动去上家申请售后，退款金额100元
          </div>
          <i class="question-icon el-icon-question"></i>
        </el-tooltip>
      </el-form-item>
      <el-form-item class="checkbox-form-item" style="display: flex;align-items: center;padding-left: 27px;">
       <el-checkbox
          v-model="form.is_partial_refund_judge_by_amount"
          :true-label="1"
          :false-label="0"
          :disabled="form.is_partial_refund_no_auto_apply !== 1"
          style="display: inline-block;"
          @change="handlePartialRefundJudgeByAmountChange"
        />
        <span style="display: inline-block;margin: 0 10px;font-size:14px;">卖出单申请部分退款金额低于</span>
        <el-input
          ref="partialRefundMaxPriceInput"
          size="small"
          class="partial-refund-no-auto-apply-max-price-input"
          v-model="form.partial_refund_no_auto_apply_max_price"
          placeholder="请输入"
        />
        <span style="display: inline-block;margin: 0 10px;font-size:14px;">元时，采购单不申请售后</span>
      </el-form-item>

      <el-divider content-position="left"><span class="divider-text">卖出单自动售后设置</span></el-divider>
      <el-form-item label="开启自动售后账号" class="pdd-account-form-item">
        <div v-if="pddAccountList.length" class="pdd-account-list">
          <el-checkbox
            v-for="item in pddAccountList"
            :key="item.id"
            v-model="item.auto_deal_dd_after_sales"
            :true-label="1"
            :false-label="0"
            :label="formatPddAccountLabel(item)"
          />
        </div>
        <p v-else class="form-tip">暂无采购账号</p>
      </el-form-item>
      <el-form-item label="退货退款" class="checkbox-form-item">
        <el-checkbox
          v-model="form.is_auto_select_supplier_return_address"
          :true-label="1"
          :false-label="0"
          label="同意买家退货退款申请时，自动选择上家退货地址"
          @change="handleAutoSelectSupplierReturnAddressChange"
        />
      </el-form-item>
      <el-form-item class="checkbox-form-item" style="padding-left: 27px;">
        <el-checkbox
          v-model="form.is_skip_select_supplier_return_address_on_pin_tui"
          :true-label="1"
          :false-label="0"
          :disabled="form.is_auto_select_supplier_return_address !== 1"
          label="卖出单售后原因为「品退」时自动跳过"
        />
      </el-form-item>
      <el-form-item class="checkbox-form-item" style="padding-left: 27px;">
        <el-checkbox
          v-model="form.is_skip_select_supplier_return_address_over_ship_days"
          :true-label="1"
          :false-label="0"
          :disabled="form.is_auto_select_supplier_return_address !== 1"
          label="卖出单发货超过10天时自动跳过"
        />
      </el-form-item>
      <el-form-item label="同意退款" class="checkbox-form-item">
        <el-checkbox
          v-model="form.is_auto_agree_sell_refund_on_purchase_refund"
          :true-label="1"
          :false-label="0"
          label="采购单退款成功后，自动同意卖出单退款申请"
          @change="handleAutoAgreeSellRefundChange"
        />
      </el-form-item>
      <el-form-item class="checkbox-form-item" style="padding-left: 27px;">
        <el-checkbox
          v-model="form.is_skip_agree_sell_refund_with_postage"
          :true-label="1"
          :false-label="0"
          :disabled="form.is_auto_agree_sell_refund_on_purchase_refund !== 1"
          label="已发货卖出单退款金额含运费时自动跳过"
        />
      </el-form-item>
      <el-form-item label="自动同意售后原因" class="auto-refund-reason-form-item">
        <div class="auto-refund-reason-panel">
          <el-checkbox
            v-model="isAutoRefundReasonCheckAll"
            :indeterminate="isAutoRefundReasonIndeterminate"
          >
            全选
          </el-checkbox>
          <el-checkbox-group v-model="form.auto_refund_reason" class="auto-refund-reason-list">
            <el-checkbox
              v-for="item in aftersaleReasonList"
              :key="item"
              :label="item"
            />
          </el-checkbox-group>
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">取 消</el-button>
      <el-button type="primary" @click="handlerConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";

const DELAY_RULE_ALL = 10
const DELAY_RULE_PRICE_RANGE = 20

const DEFAULT_FORM = {
  auto_retry_apply_refund_num: '1',
  auto_aftersale_delay_rule: DELAY_RULE_ALL,
  auto_aftersale_delay_min_price: '0',
  auto_aftersale_delay_max_price: '0',
  auto_aftersale_delay: '0',
  aftersale_carry_refund_desc: '',
  aftersale_delivery_refund_desc: '',
  aftersale_return_refund_desc: '',
  is_auto_cancel_apply: 0,
  is_aftersale_retention: 0,
  is_partial_refund_no_auto_apply: 0,
  is_partial_refund_judge_by_amount: 0,
  partial_refund_no_auto_apply_max_price: '1',
  is_auto_select_supplier_return_address: 0,
  is_skip_select_supplier_return_address_on_pin_tui: 0,
  is_skip_select_supplier_return_address_over_ship_days: 0,
  is_auto_agree_sell_refund_on_purchase_refund: 0,
  is_skip_agree_sell_refund_with_postage: 0,
  auto_refund_reason: [],
}

export default {
  name: 'AftersalesConfigSetDialog',
  data() {
    return {
      DELAY_RULE_ALL,
      DELAY_RULE_PRICE_RANGE,
      visible: false,
      loading: false,
      form: { ...DEFAULT_FORM },
      aftersaleReasonList: [],
      pddAccountList: [],
    }
  },
  computed: {
    isAutoRefundReasonCheckAll: {
      get() {
        const list = this.aftersaleReasonList
        if (!list.length) return false
        return list.every((item) => this.form.auto_refund_reason.includes(item))
      },
      set(val) {
        this.form.auto_refund_reason = val ? [...this.aftersaleReasonList] : []
      },
    },
    isAutoRefundReasonIndeterminate() {
      const selectedCount = this.form.auto_refund_reason.length
      const totalCount = this.aftersaleReasonList.length
      return selectedCount > 0 && selectedCount < totalCount
    },
  },
  methods: {
    ...mapActions({
      getUserinfoData: "ucenter/getUserinfoData",
      opBusinessSetAftersaleConfig: "ucenter/opBusinessSetAftersaleConfig",
    }),
    formatFormValue(val, defaultVal) {
      return val != null && val !== '' ? String(val) : String(defaultVal)
    },
    formatSwitchValue(val) {
      return Number(val) === 1 ? 1 : 0
    },
    formatPddAccountLabel(item = {}) {
      return `${item.phone || ''}${item.name || ''}`
    },
    formatPddAccountList(list) {
      if (!Array.isArray(list)) return []
      return list.map((item) => ({
        id: item.id,
        phone: item.phone || '',
        name: item.name || '',
        auto_deal_dd_after_sales: this.formatSwitchValue(item.auto_deal_dd_after_sales),
      }))
    },
    formatDelayRuleValue(data = {}) {
      if (data.auto_aftersale_delay_rule != null && data.auto_aftersale_delay_rule !== '') {
        return Number(data.auto_aftersale_delay_rule) === DELAY_RULE_PRICE_RANGE
          ? DELAY_RULE_PRICE_RANGE
          : DELAY_RULE_ALL
      }
      const minPrice = parseFloat(
        data.auto_aftersale_delay_min_price ?? data.auto_aftersale_min_price ?? 0
      )
      const maxPrice = parseFloat(
        data.auto_aftersale_delay_max_price ?? data.auto_aftersale_max_price ?? 0
      )
      if (minPrice > 0 || maxPrice > 0) {
        return DELAY_RULE_PRICE_RANGE
      }
      return DELAY_RULE_ALL
    },
    fillForm(data = {}) {
      const delayRule = this.formatDelayRuleValue(data)
      this.form = {
        auto_retry_apply_refund_num: this.formatFormValue(
          data.auto_retry_apply_refund_num,
          DEFAULT_FORM.auto_retry_apply_refund_num
        ),
        auto_aftersale_delay_rule: delayRule,
        auto_aftersale_delay_min_price: this.formatFormValue(
          data.auto_aftersale_delay_min_price ?? data.auto_aftersale_min_price,
          DEFAULT_FORM.auto_aftersale_delay_min_price
        ),
        auto_aftersale_delay_max_price: this.formatFormValue(
          data.auto_aftersale_delay_max_price ?? data.auto_aftersale_max_price,
          DEFAULT_FORM.auto_aftersale_delay_max_price
        ),
        auto_aftersale_delay: this.formatFormValue(
          data.auto_aftersale_delay,
          DEFAULT_FORM.auto_aftersale_delay
        ),
        aftersale_carry_refund_desc: this.formatFormValue(
          data.aftersale_carry_refund_desc,
          DEFAULT_FORM.aftersale_carry_refund_desc
        ),
        aftersale_delivery_refund_desc: this.formatFormValue(
          data.aftersale_delivery_refund_desc,
          DEFAULT_FORM.aftersale_delivery_refund_desc
        ),
        aftersale_return_refund_desc: this.formatFormValue(
          data.aftersale_return_refund_desc,
          DEFAULT_FORM.aftersale_return_refund_desc
        ),
        is_auto_cancel_apply: this.formatSwitchValue(data.is_auto_cancel_apply),
        is_aftersale_retention: this.formatSwitchValue(data.is_aftersale_retention),
        is_partial_refund_no_auto_apply: this.formatSwitchValue(data.is_partial_refund_no_auto_apply),
        is_partial_refund_judge_by_amount: this.formatSwitchValue(data.is_partial_refund_judge_by_amount),
        partial_refund_no_auto_apply_max_price: this.formatFormValue(
          data.partial_refund_no_auto_apply_max_price,
          DEFAULT_FORM.partial_refund_no_auto_apply_max_price
        ),
        is_auto_select_supplier_return_address: this.formatSwitchValue(data.is_auto_select_supplier_return_address),
        is_skip_select_supplier_return_address_on_pin_tui: this.formatSwitchValue(
          data.is_skip_select_supplier_return_address_on_pin_tui
        ),
        is_skip_select_supplier_return_address_over_ship_days: this.formatSwitchValue(
          data.is_skip_select_supplier_return_address_over_ship_days
        ),
        is_auto_agree_sell_refund_on_purchase_refund: this.formatSwitchValue(
          data.is_auto_agree_sell_refund_on_purchase_refund
        ),
        is_skip_agree_sell_refund_with_postage: this.formatSwitchValue(
          data.is_skip_agree_sell_refund_with_postage
        ),
        auto_refund_reason: Array.isArray(data.auto_refund_reason)
          ? [...data.auto_refund_reason]
          : [],
      }
      this.pddAccountList = this.formatPddAccountList(data.pdd_account_list)
    },
    handleDelayRuleChange(val) {
      if (val !== DELAY_RULE_PRICE_RANGE) {
        this.form.auto_aftersale_delay_min_price = '0'
        this.form.auto_aftersale_delay_max_price = '0'
      }
    },
    handleAutoSelectSupplierReturnAddressChange(val) {
      if (val !== 1) {
        this.form.is_skip_select_supplier_return_address_on_pin_tui = 0
        this.form.is_skip_select_supplier_return_address_over_ship_days = 0
      }
    },
    handleAutoAgreeSellRefundChange(val) {
      if (val !== 1) {
        this.form.is_skip_agree_sell_refund_with_postage = 0
      }
    },
    handlePartialRefundNoAutoApplyChange(val) {
      if (val !== 1) {
        this.form.is_partial_refund_judge_by_amount = 0
      }
    },
    focusPartialRefundMaxPriceInput() {
      this.$nextTick(() => {
        const inputRef = this.$refs.partialRefundMaxPriceInput
        if (inputRef && inputRef.focus) {
          inputRef.focus()
        }
      })
    },
    validatePartialRefundMaxPrice(showMessage = true) {
      const str = String(this.form.partial_refund_no_auto_apply_max_price ?? '').trim()
      const label = '部分退款不自动申请最高金额'
      if (str === '') {
        if (showMessage) {
          this.$message({ message: `${label}必须大于0`, type: 'warning' })
        }
        return { valid: false, value: null }
      }
      if (!/^\d+(\.\d+)?$/.test(str)) {
        if (showMessage) {
          this.$message({ message: `${label}必须大于0`, type: 'warning' })
        }
        return { valid: false, value: null }
      }
      const value = parseFloat(str)
      if (value <= 0) {
        if (showMessage) {
          this.$message({ message: `${label}必须大于0`, type: 'warning' })
        }
        return { valid: false, value: null }
      }
      return { valid: true, value }
    },
    handlePartialRefundJudgeByAmountChange(val) {
      if (val !== 1) return
      const result = this.validatePartialRefundMaxPrice(true)
      if (!result.valid) {
        this.form.is_partial_refund_judge_by_amount = 0
        this.focusPartialRefundMaxPriceInput()
      }
    },
    parseIntValue(val, label) {
      const str = String(val ?? '').trim()
      if (str === '') {
        this.$message({ message: `${label}不能为空`, type: 'warning' })
        return null
      }
      if (!/^\d+$/.test(str)) {
        this.$message({ message: `${label}请输入非负整数`, type: 'warning' })
        return null
      }
      return parseInt(str, 10)
    },
    parsePriceValue(val, label) {
      const str = String(val ?? '').trim()
      if (str === '') {
        this.$message({ message: `${label}不能为空`, type: 'warning' })
        return null
      }
      if (!/^\d+(\.\d+)?$/.test(str)) {
        this.$message({ message: `${label}请输入有效数字`, type: 'warning' })
        return null
      }
      return parseFloat(str)
    },
    getSubmitData() {
      const auto_retry_apply_refund_num = this.parseIntValue(
        this.form.auto_retry_apply_refund_num,
        '自动再申请售后次数'
      )
      if (auto_retry_apply_refund_num === null) return null

      const auto_aftersale_delay_rule = Number(this.form.auto_aftersale_delay_rule) === DELAY_RULE_PRICE_RANGE
        ? DELAY_RULE_PRICE_RANGE
        : DELAY_RULE_ALL

      const auto_aftersale_delay = this.parseIntValue(
        this.form.auto_aftersale_delay,
        '自动售后延迟时间'
      )
      if (auto_aftersale_delay === null) return null

      const result = {
        auto_retry_apply_refund_num,
        auto_aftersale_delay_rule,
        auto_aftersale_delay,
        aftersale_carry_refund_desc: String(this.form.aftersale_carry_refund_desc ?? '').trim(),
        aftersale_delivery_refund_desc: String(this.form.aftersale_delivery_refund_desc ?? '').trim(),
        aftersale_return_refund_desc: String(this.form.aftersale_return_refund_desc ?? '').trim(),
        is_auto_cancel_apply: this.formatSwitchValue(this.form.is_auto_cancel_apply),
        is_aftersale_retention: this.formatSwitchValue(this.form.is_aftersale_retention),
        is_partial_refund_no_auto_apply: this.formatSwitchValue(this.form.is_partial_refund_no_auto_apply),
        is_partial_refund_judge_by_amount: this.formatSwitchValue(this.form.is_partial_refund_judge_by_amount),
        partial_refund_no_auto_apply_max_price: 1,
        is_auto_select_supplier_return_address: this.formatSwitchValue(
          this.form.is_auto_select_supplier_return_address
        ),
        is_skip_select_supplier_return_address_on_pin_tui: this.formatSwitchValue(
          this.form.is_skip_select_supplier_return_address_on_pin_tui
        ),
        is_skip_select_supplier_return_address_over_ship_days: this.formatSwitchValue(
          this.form.is_skip_select_supplier_return_address_over_ship_days
        ),
        is_auto_agree_sell_refund_on_purchase_refund: this.formatSwitchValue(
          this.form.is_auto_agree_sell_refund_on_purchase_refund
        ),
        is_skip_agree_sell_refund_with_postage: this.formatSwitchValue(
          this.form.is_skip_agree_sell_refund_with_postage
        ),
        auto_refund_reason: [...this.form.auto_refund_reason],
        pdd_account_list: this.pddAccountList.map((item) => ({
          id: item.id,
          auto_deal_dd_after_sales: this.formatSwitchValue(item.auto_deal_dd_after_sales),
        })),
      }

      const partialRefundMaxPriceStr = String(this.form.partial_refund_no_auto_apply_max_price ?? '').trim()
      if (partialRefundMaxPriceStr !== '' && /^\d+(\.\d+)?$/.test(partialRefundMaxPriceStr)) {
        result.partial_refund_no_auto_apply_max_price = parseFloat(partialRefundMaxPriceStr)
      }

      if (auto_aftersale_delay_rule === DELAY_RULE_PRICE_RANGE) {
        const auto_aftersale_delay_min_price = this.parsePriceValue(
          this.form.auto_aftersale_delay_min_price,
          '延迟申请售后最低价格'
        )
        if (auto_aftersale_delay_min_price === null) return null

        const auto_aftersale_delay_max_price = this.parsePriceValue(
          this.form.auto_aftersale_delay_max_price,
          '延迟申请售后最高价格'
        )
        if (auto_aftersale_delay_max_price === null) return null

        result.auto_aftersale_delay_min_price = auto_aftersale_delay_min_price
        result.auto_aftersale_delay_max_price = auto_aftersale_delay_max_price
      }

      return result
    },
    open() {
      this.visible = true
      this.loading = true
      this.aftersaleReasonList = []
      this.pddAccountList = []
      this.fillForm(DEFAULT_FORM)
      this.getUserinfoData({
        data: {},
        success: (res) => {
          this.loading = false
          if (res.code === 200) {
            this.aftersaleReasonList = Array.isArray(res.data.aftersale_reason_list)
              ? res.data.aftersale_reason_list
              : []
            this.fillForm(res.data)
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        },
      })
    },
    handlerConfirm() {
      const data = this.getSubmitData()
      if (!data) return

      if (data.auto_retry_apply_refund_num < 0) {
        this.$message({ message: '自动再申请售后次数不能小于 0', type: 'warning' })
        return
      }
      if (data.auto_aftersale_delay < 0) {
        this.$message({ message: '自动售后延迟时间不能小于 0', type: 'warning' })
        return
      }
      if (data.auto_aftersale_delay_rule === DELAY_RULE_PRICE_RANGE) {
        if (data.auto_aftersale_delay_min_price <= 0 || data.auto_aftersale_delay_max_price <= 0) {
          this.$message({ message: '延迟申请售后价格区间不能为 0', type: 'warning' })
          return
        }
        if (data.auto_aftersale_delay_min_price >= data.auto_aftersale_delay_max_price) {
          this.$message({ message: '延迟申请售后最低价格须小于最高价格', type: 'warning' })
          return
        }
      }
      if (
        data.is_partial_refund_judge_by_amount === 1
        && data.is_partial_refund_no_auto_apply !== 1
      ) {
        this.$message({ message: '请先开启部分退款不自动申请售后', type: 'warning' })
        return
      }
      if (data.is_partial_refund_judge_by_amount === 1) {
        const partialRefundResult = this.validatePartialRefundMaxPrice(true)
        if (!partialRefundResult.valid) {
          this.focusPartialRefundMaxPriceInput()
          return
        }
        data.partial_refund_no_auto_apply_max_price = partialRefundResult.value
      }
      if (
        data.is_auto_select_supplier_return_address !== 1
        && (
          data.is_skip_select_supplier_return_address_on_pin_tui === 1
          || data.is_skip_select_supplier_return_address_over_ship_days === 1
        )
      ) {
        this.$message({ message: '请先开启同意买家退货退款时自动选择上家退货地址', type: 'warning' })
        return
      }
      if (
        data.is_auto_agree_sell_refund_on_purchase_refund !== 1
        && data.is_skip_agree_sell_refund_with_postage === 1
      ) {
        this.$message({ message: '请先开启采购单退款成功后自动同意卖出单退款申请', type: 'warning' })
        return
      }
      data.auto_refund_reason = Array.isArray(this.form.auto_refund_reason)
        ? [...this.form.auto_refund_reason]
        : []
      data.aftersale_carry_refund_desc = String(this.form.aftersale_carry_refund_desc ?? '').trim()
      data.aftersale_delivery_refund_desc = String(this.form.aftersale_delivery_refund_desc ?? '').trim()
      data.aftersale_return_refund_desc = String(this.form.aftersale_return_refund_desc ?? '').trim()
      this.opBusinessSetAftersaleConfig({
        data,
        success: (res) => {
          if (res.code === 200) {
            this.$message.success(res.msg)
            this.visible = false
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        },
      })
    },
    handlerCancel() {
      this.visible = false
    },
  },
}
</script>

<style scoped>
.aftersale-config-form >>> .el-form-item {
  margin-bottom: 8px;
}
.aftersale-config-form >>> .el-input {
  width: 280px;
}
.aftersale-config-form>>>.checkbox-form-item{
  margin-bottom: 20px;
}
.aftersale-config-form >>> .checkbox-form-item.el-form-item {
  align-items: center;
}
.aftersale-config-form >>> .checkbox-form-item .el-form-item__label {
  line-height: 20px;
}
.aftersale-config-form >>> .checkbox-form-item .el-form-item__content {
  line-height: 14px;
}
.aftersale-config-form >>> .checkbox-form-item .el-checkbox {
  margin: 0;
  line-height: 14px;
  display: inline-block;
}
.aftersale-config-form >>> .checkbox-form-item--with-tip.el-form-item {
  align-items: flex-start;
}
.aftersale-config-form >>> .checkbox-form-item--with-tip .el-form-item__label {
  padding-top: 0;
}
.aftersale-config-form>>>.auto-refund-reason-form-item .el-form-item__label {
  line-height: 16px;
}
.aftersale-config-form>>>.pdd-account-form-item .el-form-item__label {
  line-height: 28px;
}
.aftersale-config-form >>> .pdd-account-form-item .el-form-item__content {
  line-height: normal;
}
.pdd-account-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 24px;
  row-gap: 8px;
}
.aftersale-config-form >>> .pdd-account-list .el-checkbox {
  margin-right: 0;
  height: 28px;
  display: flex;
  align-items: center;
}
.form-tip {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #999;
}
.divider-text {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.aftersale-config-form .partial-refund-no-auto-apply-max-price-input.el-input{
  width: 60px;
}
.aftersale-config-form .delay-price-range-input.el-input {
  width: 120px;
}
.aftersale-config-form .delay-price-range-separator {
  display: inline-block;
  margin: 0 8px;
  font-size: 14px;
  color: #606266;
}
.aftersale-config-form>>> .el-checkbox__label{
  font-size: 14px !important;
  color: #606266 !important;
}
.aftersale-config-form>>> .question-icon{
  font-size: 16px;
  color: #999;
  display: inline-block;
  cursor: pointer;
  margin-left: 5px;
}
.aftersale-config-form>>> .el-checkbox__input{
  display: inline-block;
}
.aftersale-config-form >>> .auto-refund-reason-form-item .el-form-item__content {
  line-height: normal;
}
.auto-refund-reason-panel {
  width: 100%;
}
.auto-refund-reason-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 24px;
  row-gap: 8px;
  margin-top: 8px;
}
.aftersale-config-form >>> .auto-refund-reason-list .el-checkbox {
  margin-right: 0;
  height: 28px;
  display: flex;
  align-items: center;
}
</style>
